import { Browser } from "@capacitor/browser";
import { createStytchClient } from "@stytch/react";

import {
  type OAuthNavigable,
  redirectStytchOAuthToInAppBrowser,
} from "@/lib/auth/stytch-native-oauth";
import { preInitializeStytchSessionCookies } from "@/lib/auth/stytch-session-storage";
import {
  iosOrAndroid,
  VITE_STYTCH_BASE_URL,
  VITE_STYTCH_PUBLIC_TOKEN,
} from "@/lib/utils/config";

// Restore persisted session cookies before StytchClient reads them on init.
// On iOS, the OS clears cookies between app launches; tokens stored in
// @capacitor/preferences are the source of truth to re-hydrate the session.
await preInitializeStytchSessionCookies();

export const stytchClient = createStytchClient(VITE_STYTCH_PUBLIC_TOKEN, {
  keepSessionAlive: true,
  customBaseUrl: VITE_STYTCH_BASE_URL,
});

// On native, keep social-login OAuth out of the main WebView (its top-level
// navigation blanks the app); run it in an in-app browser instead. See
// redirectStytchOAuthToInAppBrowser for the full rationale.
if (iosOrAndroid) {
  // `navigate` is an internal override seam not in the public OAuth client type.
  redirectStytchOAuthToInAppBrowser(
    stytchClient.oauth as unknown as OAuthNavigable,
    (url) => {
      void Browser.open({ url });
    },
  );
}
